export default __webpack_public_path__ + "static/media/25.b91e3b1e.jpeg";